const ENTITY_PATH_SEGMENTS = {
  clients: 'contact',
  contacts: 'contact',
  appointments: 'appointment',
  staff: 'staff',
  services: 'service',
  invoices: 'invoice',
  payments: 'payment',
  leads: 'lead',
  campaigns: 'campaign',
};

const UID_PATTERN = /^[a-z0-9]{8,}$/i;

const POV_ROUTE_ENTITY_MAP = {
  RolePage: { uidParam: 'uid' },
  StaffRolePage: { uidParam: 'staffUid' },
  'resource-type-details': { uidParam: 'uid' },
  staffProfile: { uidParam: 'uid', type: 'staff' },
};

const extractEntityFromPath = (path) => {
  const segments = path.split('/').filter(Boolean);
  for (let i = 0; i < segments.length - 1; i++) {
    const type = ENTITY_PATH_SEGMENTS[segments[i]];
    if (type && UID_PATTERN.test(segments[i + 1])) {
      return { type, uid: segments[i + 1] };
    }
  }
  return null;
};

const extractMatterFromQuery = (route) => {
  const matterUid = route.query?.matter_uid;
  if (!matterUid) return null;
  return { type: 'matter', uid: matterUid };
};

const resolveEntities = (route) => {
  const povDef = POV_ROUTE_ENTITY_MAP[route.name];
  if (povDef) {
    const uid = route.params[povDef.uidParam] || null;
    if (!uid) return [];
    return [{ type: povDef.type || route.name, uid }];
  }

  const entities = [];
  const pathEntity = extractEntityFromPath(route.path);
  if (pathEntity) entities.push(pathEntity);

  const matterEntity = extractMatterFromQuery(route);
  if (matterEntity) entities.push(matterEntity);

  return entities;
};

const buildAdditionalContext = (route, pageTitle) => {
  const context = { page: pageTitle || route.name || 'Unknown' };
  const entities = resolveEntities(route);
  if (entities.length) context.entities = entities;
  return context;
};

export default buildAdditionalContext;
